import React from 'react';
import PropTypes from 'prop-types';
import {useColor} from "../contexts/ColorContext";
import {HashLoader} from "react-spinners";

interface LoaderProps {
    color?: string;
}

const propTypes = {
    color: PropTypes.string,
}

const defaultProps = {
    color: undefined,
}

const Loader = ({ color }: LoaderProps) => {
    const {colors} = useColor()
    const loaderColor = color || colors.primary

    return (
        <div className="d-flex justify-content-center align-items-center my-5" style={{ height: 'inherit' }}>
            <HashLoader color={loaderColor}/>
        </div>
    );
}

Loader.propTypes = propTypes;
Loader.defaultProps = defaultProps;

export default Loader;
